export const builtins = () => [
	{
		name: 'Chapbook',
		url: 'story-formats/chapbook-1.2.3/format.js',
		version: '1.2.3'
	},
	{
		name: 'Harlowe',
		url: 'story-formats/harlowe-1.2.4/format.js',
		version: '1.2.4'
	},
	{
		name: 'Harlowe',
		url: 'story-formats/harlowe-2.1.0/format.js',
		version: '2.1.0'
	},
	{
		name: 'Harlowe',
		url: 'story-formats/harlowe-3.3.5/format.js',
		version: '3.3.5'
	},
	{
		name: 'Paperthin',
		url: 'story-formats/paperthin-1.0.0/format.js',
		version: '1.0.0'
	},
	{
		name: 'Snowman',
		url: 'story-formats/snowman-1.4.0/format.js',
		version: '1.4.0'
	},
	{
		name: 'Snowman',
		url: 'story-formats/snowman-2.0.2/format.js',
		version: '2.0.2',
		userAdded: false
	},
	{
		name: 'SugarCube',
		url: 'story-formats/sugarcube-1.0.35/format.js',
		version: '1.0.35'
	},
	{
		name: 'SugarCube',
		url: 'story-formats/sugarcube-2.36.1/format.js',
		version: '2.36.1'
	}
];
